var path = './admin/title_bar.html';
var html = "<div id=\"admin-title-bar\" ng-if=\"user.Administrator\">\n    <div class=\"title\" translate>ADMIN.TITLE.ADMINISTRATION_DASHBOARD</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;